import React from 'react'
import clsx from 'clsx'
import { Typography } from '@material-ui/core'
import useTakeBackStyle from '../../components/TakeBack/TakeBack.style'
import Price from '../Shop/Price'

type Tprops = {
  price: number
  incentiveValue: number
}

const TakeBackPrice = ({ price, incentiveValue }: Tprops) => {
  const classes = useTakeBackStyle()
  let amount
  if (incentiveValue !== 0) {
    amount = price + (price * incentiveValue) / 100
  } else {
    amount = price
  }
  return (
    <Typography
      component="div"
      color="primary"
      className={clsx('takeBack__price', classes.price)}
    >
      <Price amount={amount} showDayOrMonth={false} />
    </Typography>
  )
}

export default TakeBackPrice
